import {endOfWeek, format, parse, startOfWeek} from 'date-fns';

import type {Day} from 'date-fns';


export function getDateRange(
    date: string | Date | null,
    weekStartsOn: Day,
    dateFormat: string,
    asArray: true): Date[];
export function getDateRange(
    date: string | Date | null,
    weekStartsOn: Day, dateFormat: string,
    asArray?: false): string;
export function getDateRange(
    date: string | Date | null,
    weekStartsOn: Day,
    dateFormat: string,
    asArray: boolean = false,
) {
    if (!date) {
        return asArray ? [] : '';
    }

    const inputDate = date instanceof Date ? date : parse(date, dateFormat, new Date());

    const start = startOfWeek(inputDate, {weekStartsOn});
    const end = new Date(endOfWeek(inputDate, {weekStartsOn}).setMilliseconds(0));

    if (asArray) {
        return [start, end];
    }

    return `${format(start, dateFormat)} to ${format(end, dateFormat)}`;
}
